export default __webpack_public_path__ + "static/media/ventas_icon_white.110d778c.svg";